import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AlertBox from 'components/ui/AlertBox';

const GetAlertBox = ({ success, error }) => {
  if (error) {
    return (
      <AlertBox dataCy="issue-ticket-error" variant={AlertBox.variants.ERROR}>
        <FormattedMessage id="issueTickets.failed" />
      </AlertBox>
    );
  }

  if (success) {
    return (
      <AlertBox dataCy="issue-ticket-success" variant={AlertBox.variants.SUCCESS}>
        <FormattedMessage id="issueTickets.success" />
      </AlertBox>
    );
  }

  return null;
};

GetAlertBox.propTypes = {
  success: PropTypes.bool,
  error: PropTypes.bool
};

export default GetAlertBox;
